export default __webpack_public_path__ + "static/media/time-spent.2ac98710.svg";